"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useAdaptiveCardsPackage;

var _useAdaptiveCardsContext = _interopRequireDefault(require("./internal/useAdaptiveCardsContext"));

function useAdaptiveCardsPackage() {
  var _useAdaptiveCardsCont = (0, _useAdaptiveCardsContext.default)(),
      adaptiveCardsPackage = _useAdaptiveCardsCont.adaptiveCardsPackage;

  return [adaptiveCardsPackage];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9hZGFwdGl2ZUNhcmRzL2hvb2tzL3VzZUFkYXB0aXZlQ2FyZHNQYWNrYWdlLnRzIl0sIm5hbWVzIjpbInVzZUFkYXB0aXZlQ2FyZHNQYWNrYWdlIiwiYWRhcHRpdmVDYXJkc1BhY2thZ2UiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUNBOztBQUVlLFNBQVNBLHVCQUFULEdBQTJEO0FBQ3hFLDhCQUFpQyx1Q0FBakM7QUFBQSxNQUFRQyxvQkFBUix5QkFBUUEsb0JBQVI7O0FBRUEsU0FBTyxDQUFDQSxvQkFBRCxDQUFQO0FBQ0QiLCJzb3VyY2VSb290IjoiYnVuZGxlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBBZGFwdGl2ZUNhcmRzUGFja2FnZSBmcm9tICcuLi8uLi90eXBlcy9BZGFwdGl2ZUNhcmRzUGFja2FnZSc7XG5pbXBvcnQgdXNlQWRhcHRpdmVDYXJkc0NvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VBZGFwdGl2ZUNhcmRzQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZUFkYXB0aXZlQ2FyZHNQYWNrYWdlKCk6IFtBZGFwdGl2ZUNhcmRzUGFja2FnZV0ge1xuICBjb25zdCB7IGFkYXB0aXZlQ2FyZHNQYWNrYWdlIH0gPSB1c2VBZGFwdGl2ZUNhcmRzQ29udGV4dCgpO1xuXG4gIHJldHVybiBbYWRhcHRpdmVDYXJkc1BhY2thZ2VdO1xufVxuIl19